<template>
  <!-- Page Content -->
  <div
    ref="chartContainer"
    class="d-flex flex-column"
    v-bind:class="[isDynamicSize ? 'dynamic-ta-chart' : 'no_nav_height']"
  >
    <div class="row f-row justify-content-center h-100">
      <div class="col col-12 text-center h-100">
        <!-- Chart 1 -->
        <div
          style="width: 100%;"
          :class="[
            isDynamicSize
              ? nSelected <= 1
                ? nCharts === 0
                  ? 'ta-0chart'
                  : nCharts === 1
                  ? 'ta-1chart'
                  : nCharts === 2
                  ? 'ta-2chart'
                  : 'ta-3chart'
                : nCharts === 0
                ? 'ta-0chart-2'
                : nCharts === 1
                ? 'ta-1chart-2'
                : nCharts === 2
                ? 'ta-2chart-2'
                : 'ta-3chart-2'
              : nCharts === 0
              ? 'ta-0-main-chart'
              : nCharts === 1
              ? 'ta-1-main-chart'
              : nCharts === 2
              ? 'ta-2-main-chart'
              : 'ta-3-main-chart',
          ]"
        >
          <!-- Row: title -->
          <div class="row f-row" v-if="!small">
            <div
              class="markets-chart-title col col-12 d-flex align-items-center"
            >
              <div class="col col-6">
                {{
                  title
                    ? title.charAt(0).toUpperCase() +
                      title.slice(1).toLowerCase()
                    : "..."
                }}
                {{ isCandles ? "candles" : "line chart" }} for
                <span
                  style="color: var(--textactive)"
                  v-if="isCurrency && selectedCurrency !== 'na'"
                >
                  {{ selectedCurrency.slice(0, 3) }}/{{
                    selectedCurrency.slice(3, 6)
                  }}
                </span>
                <span style="color: var(--textactive)" v-else-if="!isCurrency">
                  {{ commodityStringLong }}
                </span>
              </div>
              <slot name="spot"></slot>
            </div>
          </div>
          <!-- Row: controls and labels -->
          <div
            class="row f-row mt-1"
            style="vertical-align: middle!important; padding: 0 55px 0 12px!important;"
          >
            <div
              v-if="small && !verySmall"
              class="col col-auto row-middle-titles"
              style="justify-content: left;"
            >
              <span
                class="mr-1"
                style="color: var(--textactive); font-size: 1.2rem;"
              >
                {{ selectedCurrency }}</span
              >
              <span class="textCandleChart mr-2">
                {{ title }}
                {{ isCandles ? "candles" : "line chart" }}</span
              >
            </div>
            <div
              v-if="!small"
              class="txt-label-primary-2 text-center"
              style="width: 14rem; padding: 0 5px 0 0!important;"
            >
              <PeriodsIndepComponent @eventOnChangeDWM="onChangeDWM" />
            </div>
            <div
              v-else
              class="txt-label-primary-2 text-center col col-auto ml-1 mr-1"
            >
              <span style="padding: 0 5px 0 5px">
                <HoverMultiSelection
                  :alignLeft="small || verySmall"
                  :btnWidth="'5rem'"
                  :options="[
                    { label: 'Daily', value: 'day' },
                    { label: 'Weekly', value: 'week' },
                    { label: 'Monthly', value: 'month' },
                  ]"
                  :selected="title"
                  @eventOnChangeOption="onChangeDWMSmall"
                />
              </span>
            </div>
            <div
              v-if="!small"
              class="txt-label-primary-2 text-center"
              style="width: 24rem!important; padding: 0 10px 0 5px!important;"
            >
              <IntervalsIndepComponent
                :initPickedDateInterval="pickedDateInterval"
                :nineMonths="false"
                @eventOnChangeInterval="onChangeInterval"
              />
            </div>
            <div v-else class="txt-label-primary-2 text-center col col-auto">
              <span style="padding: 0 5px 0 5px">
                <HoverMultiSelection
                  :alignLeft="small || verySmall"
                  :btnWidth="'3rem'"
                  :options="options"
                  :selected="pickedDateInterval"
                  @eventOnChangeOption="onChangeIntervalSmall"
                />
              </span>
            </div>
            <div class="col col-cx f-row row-middle-titles" v-if="!small">
              <TechnicalAnalysisInfo
                :dateTitle="dateTitle"
                :priceLegend="priceLegend"
                :show20ma="show20ma"
                :show40ma="show40ma"
                :show3ma="show3ma"
                :ma1="ma1"
                :ma2="ma2"
                :ma3="ma3"
                :showBoll="showBoll"
              />
            </div>
            <div
              :ref="'containerDiv' + chartName"
              class="col col-cx f-row row-middle-titles"
              style="color: var(--textactive)"
              v-else
            >
              <!-- Always visible -->
              <span class="inh ml-1 mr-2">
                {{ priceLegend["date"] | dateFormat }}
              </span>

              <!-- Visible only if small -->
              <template v-if="!isSmall">
                <span class="inactive-txt">O:</span>
                <span class="inh ml-1 mr-2">
                  {{ priceLegend["open"] | priceFormat }}
                </span>
                <span class="inactive-txt">H:</span>
                <span class="inh ml-1 mr-2">
                  {{ priceLegend["high"] | priceFormat }}
                </span>
                <span class="inactive-txt">L:</span>
                <span class="inh ml-1 mr-2">
                  {{ priceLegend["low"] | priceFormat }}
                </span>
              </template>

              <!-- Always visible -->
              <span class="inactive-txt">C:</span>
              <span
                class="inh ml-1 mr-2"
                style="font-size: 1.2rem !important;"
                :style="{
                  color:
                    priceLegend['change'] < 0
                      ? 'var(--red)'
                      : 'var(--symmetry-h)',
                }"
              >
                {{ priceLegend["close"] | priceFormat }}
              </span>
              <span class="inactive-txt">Δ</span>
              <span
                class="inh ml-1 mr-2"
                style="font-size: 1.2rem !important;"
                :style="{
                  color:
                    priceLegend['change'] < 0
                      ? 'var(--red)'
                      : 'var(--symmetry-h)',
                }"
              >
                {{ priceLegend["change"] | percFormat }}
              </span>
            </div>
          </div>

          <!-- Row: Chart -->
          <div
            style="width: 100%; position: relative !important;"
            v-bind:class="[
              isDynamicSize
                ? 'dynamic-ta-chart-fill'
                : nSelected <= 1
                ? nCharts === 0
                  ? 'ta-0chart'
                  : nCharts === 1
                  ? 'ta-1chart'
                  : nCharts === 2
                  ? 'ta-2chart'
                  : 'ta-3chart'
                : nCharts === 0
                ? 'ta-0chart-2'
                : nCharts === 1
                ? 'ta-1chart-2'
                : nCharts === 2
                ? 'ta-2chart-2'
                : 'ta-3chart-2',
            ]"
          >
            <!-- Row: legend -->
            <div
              class="row f-row"
              v-bind:class="[small ? 'ta_legend_small' : 'ta_legend_large']"
            >
              <div
                class="col col-auto mr-2"
                style="font-size: 0.8rem!important;"
              >
                <input
                  type="button"
                  :id="'linesOrCandles' + chartName"
                  @click="onUserCandlesLineSelect"
                />
                <label
                  style="cursor: pointer;"
                  :for="'linesOrCandles' + chartName"
                >
                  <div class="triangle-topleft" v-if="isCandles"></div>
                  <i class="fa fa-minus expo-color" v-else></i>
                  <span class="ml-1" :class="{ active: isCandles }">{{
                    isCandles ? "Up/down" : "Line"
                  }}</span>
                </label>
              </div>
              <div
                class="col col-auto mr-2"
                style="font-size: 0.8rem!important;"
              >
                <input
                  type="button"
                  :id="'showOrHide20ma' + chartName"
                  @click="showHideMA20"
                />
                <label
                  style="cursor: pointer;"
                  :for="'showOrHide20ma' + chartName"
                >
                  <i
                    class="fa fa-minus"
                    style="color:var(--net)"
                    v-if="show20ma"
                  ></i>
                  <i class="fa fa-eye inactive-color" v-else></i>
                  <span :class="{ active: show20ma }">
                    MA
                    <span v-show="show20ma"
                      >(<label>
                        <input
                          v-model.number.lazy="ma1"
                          @change="onUserMA1Change"
                          placeholder="20"
                          class="custom-input-3"
                        /> </label
                      >)</span
                    >
                  </span>
                </label>
              </div>
              <div
                class="col col-auto mr-2"
                style="font-size: 0.8rem!important;"
              >
                <input
                  type="button"
                  :id="'showOrHide40ma' + chartName"
                  @click="showHideMA40"
                />
                <label
                  style="cursor: pointer;"
                  :for="'showOrHide40ma' + chartName"
                >
                  <i
                    class="fa fa-minus"
                    style="color:var(--red)"
                    v-if="show40ma"
                  ></i>
                  <i class="fa fa-eye inactive-color" v-else></i>
                  <span :class="{ active: show40ma }">
                    MA
                    <span v-show="show40ma"
                      >(<label>
                        <input
                          v-model.number.lazy="ma2"
                          @change="onUserMA2Change"
                          placeholder="40"
                          class="custom-input-3"
                        /> </label
                      >)</span
                    >
                  </span>
                </label>
              </div>
              <div
                class="col col-auto mr-2"
                style="font-size: 0.8rem!important;"
              >
                <input
                  type="button"
                  :id="'showOrHide3ma' + chartName"
                  @click="showHideMA3"
                />
                <label
                  style="cursor: pointer;"
                  :for="'showOrHide3ma' + chartName"
                >
                  <i
                    class="fa fa-minus"
                    style="color:var(--fwd)"
                    v-if="show3ma"
                  ></i>
                  <i class="fa fa-eye inactive-color" v-else></i
                  ><span :class="{ active: show3ma }">
                    MA
                    <span v-show="show3ma"
                      >(<label>
                        <input
                          v-model.number.lazy="ma3"
                          @change="onUserMA3Change"
                          placeholder="100"
                          class="custom-input-3"
                        /> </label
                      >)</span
                    >
                  </span>
                </label>
              </div>
              <div
                class="col col-auto mr-2"
                style="font-size: 0.8rem!important;"
              >
                <input
                  type="button"
                  :id="'showOrHideBoll' + chartName"
                  @click="showHideBoll"
                />
                <label
                  style="cursor: pointer;"
                  :for="'showOrHideBoll' + chartName"
                >
                  <div v-if="showBoll" class="square-border-hedge"></div>
                  <i class="fa fa-eye inactive-color" v-else></i
                  ><span class="ml-1" :class="{ active: showBoll }">{{
                    small ? "Boll" : "Bollinger"
                  }}</span>
                </label>
              </div>
              <div
                class="col col-auto mr-2"
                style="font-size: 0.8rem!important;"
              >
                <input
                  type="button"
                  :id="'showOrHideRSI' + chartName"
                  @click="showHideRSI"
                />
                <label
                  style="cursor: pointer;"
                  :for="'showOrHideRSI' + chartName"
                >
                  <i
                    class="fa fa-eye"
                    v-bind:class="[showRSI ? 'active-color' : 'inactive-color']"
                  ></i
                  ><span :class="{ active: showRSI }">
                    RSI
                    <span v-show="showRSI"
                      >(<label>
                        <input
                          v-model.number.lazy="rsi"
                          @change="onUserRSIChange"
                          placeholder="20"
                          class="custom-input-3"
                        /> </label
                      >)</span
                    >
                  </span>
                </label>
              </div>
              <div
                class="col col-auto mr-2"
                style="font-size: 0.8rem!important;"
              >
                <input
                  type="button"
                  :id="'showOrHideMACD' + chartName"
                  @click="showHideMACD"
                />
                <label
                  style="cursor: pointer;"
                  :for="'showOrHideMACD' + chartName"
                >
                  <i
                    class="fa fa-eye"
                    v-bind:class="[
                      showMACD ? 'active-color' : 'inactive-color',
                    ]"
                  ></i
                  ><span class="ml-1" :class="{ active: showMACD }">
                    MACD
                    <span v-show="showMACD"
                      >(<label>
                        <input
                          v-model.number.lazy="md1"
                          @change="onUserMACDChange"
                          placeholder="20"
                          class="custom-input-3"
                        /> </label
                      >,
                      <label>
                        <input
                          v-model.number.lazy="md2"
                          @change="onUserMACDChange"
                          placeholder="20"
                          class="custom-input-3"
                        /> </label
                      >,
                      <label>
                        <input
                          v-model.number.lazy="md3"
                          @change="onUserMACDChange"
                          placeholder="20"
                          class="custom-input-3"
                        /> </label
                      >)</span
                    >
                  </span>
                </label>
              </div>
              <div
                class="col col-auto mr-2"
                style="font-size: 0.8rem!important;"
              >
                <input
                  type="button"
                  :id="'showOrHideSTOCH' + chartName"
                  @click="showHideSTOCH"
                />
                <label
                  style="cursor: pointer;"
                  :for="'showOrHideSTOCH' + chartName"
                >
                  <i
                    class="fa fa-eye"
                    v-bind:class="[
                      showSTOCH ? 'active-color' : 'inactive-color',
                    ]"
                  ></i
                  ><span class="ml-1" :class="{ active: showSTOCH }"
                    >{{ small ? "Stoch" : "Stochastic" }}
                    <span v-show="showSTOCH"
                      >(<label>
                        <input
                          v-model.number.lazy="stoch1"
                          @change="onUserSTOCHChange"
                          placeholder="20"
                          class="custom-input-3"
                        /> </label
                      >,
                      <label>
                        <input
                          v-model.number.lazy="stoch2"
                          @change="onUserSTOCHChange"
                          placeholder="20"
                          class="custom-input-3"
                        /> </label
                      >)</span
                    >
                  </span>
                </label>
              </div>

              <div
                v-show="fibonacci != null"
                class="col col-auto mr-2"
                style="font-size: 0.8rem!important;"
              >
                <input
                  type="button"
                  :id="'showOrHideFibo' + chartName"
                  @click="showHideFibo"
                />
                <label
                  style="cursor: pointer;"
                  :for="'showOrHideFibo' + chartName"
                >
                  <i
                    class="fa fa-eye"
                    v-bind:class="[
                      showFibo ? 'active-color' : 'inactive-color',
                    ]"
                  ></i
                  ><span class="ml-1" :class="{ active: showFibo }"
                    >{{ small ? "Fibo" : "Fibonacci" }}
                    <span v-show="showFibo">
                      (<input
                        type="button"
                        :id="'showOrHideFiboR' + chartName"
                        style="padding: 0 1px 0 1px!important;"
                        @click="onUserShowHideFiboR"
                      />
                      <label
                        style="cursor: pointer;"
                        :for="'showOrHideFiboR' + chartName"
                      >
                        <div class="btn-fibo-on v-align" v-if="showFiboR">
                          R
                        </div>
                        <div class="btn-fibo-off v-align" v-else>
                          R
                        </div>
                      </label>
                      <input
                        type="button"
                        :id="'showOrHideFiboE' + chartName"
                        style="padding: 0 1px 0 1px!important;"
                        @click="onUserShowHideFiboE"
                      />
                      <label
                        style="cursor: pointer;"
                        :for="'showOrHideFiboE' + chartName"
                      >
                        <div class="btn-fibo-on v-align" v-if="showFiboE">
                          E
                        </div>
                        <div class="btn-fibo-off v-align" v-else>
                          E
                        </div>
                      </label>
                      <!-- <input
                    type="button"
                    :id="'showOrHideFiboTE' + chartName"
                    class="btn detailView"
                    @click="onUserShowHideFiboTE"
                  />
                  <label
                    style="cursor: pointer;"
                    :for="'showOrHideFiboTE' + chartName"
                  >
                    <div class="btn-fibo-on v-align" v-if="showFiboTE">
                      TE
                    </div>
                    <div class="btn-fibo-off v-align" v-else>
                      TE
                    </div>
                  </label> -->
                      <TermIntervals
                        :initTerm="fiboTerm"
                        :small="small"
                        @eventOnChangeTerm="onChangeFiboTerm"
                      />
                      <input
                        type="button"
                        :id="'showOrHideFiboDec' + chartName"
                        style="padding: 0 1px 0 1px!important;"
                        @click="onUserDecreaseFibonacci"
                      />
                      <label
                        style="cursor: pointer;"
                        :for="'showOrHideFiboDec' + chartName"
                      >
                        <div class="btn-arrow-l v-align text-center"></div>
                      </label>
                      <input
                        type="button"
                        :id="'showOrHideFiboInc' + chartName"
                        style="padding: 0 1px 0 1px!important;"
                        @click="onUserIncreaseFibonacci"
                      />
                      <label
                        style="cursor: pointer;"
                        :for="'showOrHideFiboInc' + chartName"
                      >
                        <div
                          class="btn-arrow-r v-align text-center"
                        ></div> </label
                      >&nbsp;)</span
                    >
                  </span>
                </label>
              </div>
              <div
                v-show="pivots !== null"
                class="col col-auto mr-2"
                style="font-size: 0.8rem!important;"
              >
                <input
                  type="button"
                  :id="'showOrHidePivots' + chartName"
                  @click="showHidePivots"
                />
                <label
                  style="cursor: pointer;"
                  :for="'showOrHidePivots' + chartName"
                >
                  <i
                    class="fa fa-eye"
                    v-bind:class="[
                      showPivots ? 'active-color' : 'inactive-color',
                    ]"
                  ></i>
                  <span :class="{ active: showPivots }"> Pivots</span>
                </label>
              </div>

              <div
                class="col col-auto mr-2"
                style="font-size: 0.8rem!important;"
              >
                <input type="button" :id="'trendLine' + chartName" />
                <label style="cursor: pointer;" :for="'trendLine' + chartName">
                  <trendLine :id="'trendLine' + chartName" class="trendLines" />
                  <span class="ml-1">Trendline</span>
                </label>
              </div>

              <div
                class="col col-cx text-right"
                style="font-size: 0.8rem!important; color: var(--textactive)"
              >
                {{ chartDateRange }}
              </div>
            </div>

            <div class="row f-row h-100">
              <div
                class="col col-12 text-center progress-div"
                style="top: calc(55vh - 128px);"
                v-if="showLoading && !small"
              >
                <QSLoading
                  :isLoading="showLoading && !small"
                  :size="40"
                  :colorTheme="colorTheme"
                />
              </div>
              <div
                class="col col-12 text-center progress-div"
                style="top: calc(30vh - 80px);"
                v-else-if="showLoading && small"
              >
                <QSLoading
                  :isLoading="showLoading && small"
                  :size="40"
                  :colorTheme="colorTheme"
                />
              </div>
              <div
                class="col col-12 text-center"
                v-else-if="chartDataRaw.length === 0"
                style="position: absolute; left: 0; top: calc(50vh - 128px); z-index: 10000000;"
              >
                No Data Available
              </div>
              <div class="col col-12" style="height:100%; width:100%">
                <div
                  v-if="chartNum === 1"
                  class="d-flex flex-column h-100"
                  id="technical-analysis-chart-div"
                >
                  <svg id="svg-technical-analysis"></svg>
                </div>
                <div
                  v-else-if="chartNum === 2"
                  class="d-flex flex-column"
                  id="technical-analysis-chart-div-2"
                  style="width: 100%; height:100%"
                >
                  <svg id="svg-technical-analysis-2"></svg>
                </div>
                <div
                  v-else-if="chartNum === 3"
                  class="d-flex flex-column"
                  id="technical-analysis-chart-div-3"
                  style="width: 100%; height:100%"
                >
                  <svg id="svg-technical-analysis-3"></svg>
                </div>
                <div
                  v-else-if="chartNum === 4"
                  class="d-flex flex-column"
                  id="technical-analysis-chart-div-4"
                  style="width: 100%; height:100%"
                >
                  <svg id="svg-technical-analysis-4"></svg>
                </div>
                <div
                  v-else-if="chartNum === 5"
                  class="d-flex flex-column"
                  id="technical-analysis-chart-div-5"
                  style="width: 100%; height:100%"
                >
                  <svg id="svg-technical-analysis-5"></svg>
                </div>
                <div
                  v-else-if="chartNum === 6"
                  class="d-flex flex-column"
                  id="technical-analysis-chart-div-6"
                  style="width: 100%; height:100%"
                >
                  <svg id="svg-technical-analysis-6"></svg>
                </div>
              </div>
              <div
                class="pivots-div text-center"
                v-if="showPivots && !showLoading && pivots !== null"
              >
                <DataTable :value="pivots" class="p-datatable-sm">
                  <Column field="name" header="">
                    <template #body="{data}">
                      {{ data.name }}
                    </template>
                  </Column>
                  <Column field="value" :header="isCurrency ? 'Rate' : 'Price'">
                    <template #body="{data}">
                      {{ data.value | priceFormat }}
                    </template>
                  </Column>
                </DataTable>
              </div>
            </div>
          </div>
        </div>

        <!-- Chart RSI -->
        <div
          v-show="showRSI"
          style="width: 100%;"
          v-bind:class="[
            nSelected <= 1
              ? nCharts === 1
                ? 'ta-small-1chart'
                : nCharts === 2
                ? 'ta-small-2chart'
                : 'ta-small-3chart'
              : nCharts === 1
              ? 'ta-small-1chart-2'
              : nCharts === 2
              ? 'ta-small-2chart-2'
              : 'ta-small-3chart-2',
          ]"
        >
          <!-- Row: Chart -->
          <div class="row f-row h-100" v-show="showRSI">
            <!-- legend -->
            <div
              style="position: relative; left: 1.5%; top: 12px; font-size: 0.8rem; line-height: 20px; z-index: 100000"
            >
              <i class="fa fa-minus" style="color: var(--expo)"></i> RSI<span
                v-show="!small"
                >:
                <div
                  id="inforsiTA"
                  class="candle-hover-info text-center inline-ul"
                >
                  -
                </div>
              </span>
            </div>
            <div class="h-100" style="width: 100%;">
              <div
                v-if="chartNum === 1"
                class="h-100"
                id="rsi-chart-div"
                style="width: 100%; position: relative; left: 0; top: -20px;"
              >
                <svg id="svg-rsi"></svg>
              </div>
              <div
                v-else-if="chartNum === 2"
                class="h-100"
                id="rsi-chart-div-2"
                style="width: 100%; position: relative; left: 0; top: -20px;"
              >
                <svg id="svg-rsi-2"></svg>
              </div>
              <div
                v-else-if="chartNum === 3"
                class="h-100"
                id="rsi-chart-div-3"
                style="width: 100%; position: relative; left: 0; top: -20px;"
              >
                <svg id="svg-rsi-3"></svg>
              </div>
              <div
                v-else-if="chartNum === 4"
                class="h-100"
                id="rsi-chart-div-4"
                style="width: 100%; position: relative; left: 0; top: -20px;"
              >
                <svg id="svg-rsi-4"></svg>
              </div>
              <div
                v-else-if="chartNum === 5"
                class="h-100"
                id="rsi-chart-div-5"
                style="width: 100%; position: relative; left: 0; top: -20px;"
              >
                <svg id="svg-rsi-5"></svg>
              </div>
              <div
                v-else-if="chartNum === 6"
                class="h-100"
                id="rsi-chart-div-6"
                style="width: 100%; position: relative; left: 0; top: -20px;"
              >
                <svg id="svg-rsi-6"></svg>
              </div>
            </div>
          </div>
        </div>

        <!-- Chart MACD -->
        <div
          v-show="showMACD"
          style="width: 100%;"
          v-bind:class="[
            nSelected <= 1
              ? nCharts === 1
                ? 'ta-small-1chart'
                : nCharts === 2
                ? 'ta-small-2chart'
                : 'ta-small-3chart'
              : nCharts === 1
              ? 'ta-small-1chart-2'
              : nCharts === 2
              ? 'ta-small-2chart-2'
              : 'ta-small-3chart-2',
          ]"
        >
          <!-- Row: Chart -->
          <div class="row f-row h-100" v-show="showMACD">
            <!-- legend -->
            <div
              style="position: relative; left: 1.5%; top: 12px; font-size: 0.8rem; line-height: 20px;  z-index: 100000"
            >
              <i class="fa fa-minus" style="color: var(--expo)"></i> MACD<span
                v-show="!small"
                >:
                <div
                  id="infomacdTA"
                  class="candle-hover-info text-center inline-ul"
                >
                  -
                </div>
              </span>
              &nbsp;&nbsp;
              <i class="fa fa-minus" style="color: var(--dn-candles)"></i>
              Signal<span v-show="!small"
                >:
                <div
                  id="infomacdSignalTA"
                  class="candle-hover-info text-center inline-ul"
                >
                  -
                </div>
              </span>
              &nbsp;&nbsp;
              <div class="triangle-topleft"></div>
              Histogram<span v-show="!small"
                >:
                <div
                  id="infomacdHistogramTA"
                  class="candle-hover-info text-center inline-ul"
                >
                  -
                </div>
              </span>
            </div>
            <div class="h-100" style="width: 100%;">
              <div
                v-if="chartNum === 1"
                class="h-100"
                id="macd-chart-div"
                style="width: 100%; position: relative; left: 0; top: -20px;"
              >
                <svg id="svg-macd"></svg>
              </div>
              <div
                v-else-if="chartNum === 2"
                class="h-100"
                id="macd-chart-div-2"
                style="width: 100%; position: relative; left: 0; top: -20px;"
              >
                <svg id="svg-macd-2"></svg>
              </div>
              <div
                v-else-if="chartNum === 3"
                class="h-100"
                id="macd-chart-div-3"
                style="width: 100%; position: relative; left: 0; top: -20px;"
              >
                <svg id="svg-macd-3"></svg>
              </div>
              <div
                v-else-if="chartNum === 4"
                class="h-100"
                id="macd-chart-div-4"
                style="width: 100%; position: relative; left: 0; top: -20px;"
              >
                <svg id="svg-macd-4"></svg>
              </div>
              <div
                v-else-if="chartNum === 5"
                class="h-100"
                id="macd-chart-div-5"
                style="width: 100%; position: relative; left: 0; top: -20px;"
              >
                <svg id="svg-macd-5"></svg>
              </div>
              <div
                v-else-if="chartNum === 6"
                class="h-100"
                id="macd-chart-div-6"
                style="width: 100%; position: relative; left: 0; top: -20px;"
              >
                <svg id="svg-macd-6"></svg>
              </div>
            </div>
          </div>
        </div>

        <!-- Chart STOCH -->
        <div
          v-show="showSTOCH"
          style="width: 100%;"
          v-bind:class="[
            nSelected <= 1
              ? nCharts === 1
                ? 'ta-small-1chart'
                : nCharts === 2
                ? 'ta-small-2chart'
                : 'ta-small-3chart'
              : nCharts === 1
              ? 'ta-small-1chart-2'
              : nCharts === 2
              ? 'ta-small-2chart-2'
              : 'ta-small-3chart-2',
          ]"
        >
          <!-- Row: Chart -->
          <div class="row f-row h-100" v-show="showSTOCH">
            <!-- legend -->
            <div
              style="position: relative; left: 1.5%; top: 12px; font-size: 0.8rem; line-height: 20px;  z-index: 100000"
            >
              <i class="fa fa-minus" style="color: var(--expo)"></i> Stochastic
              %K<span v-show="!small"
                >:
                <div
                  id="infostochPKTA"
                  class="candle-hover-info text-center inline-ul"
                >
                  -
                </div> </span
              >&nbsp;&nbsp;
              <i class="fa fa-minus" style="color: var(--dn-candles)"></i>
              Stochastic %D<span v-show="!small"
                >:
                <div
                  id="infostochPDTA"
                  class="candle-hover-info text-center inline-ul"
                >
                  -
                </div>
              </span>
            </div>
            <div class="h-100" style="width: 100%;">
              <div
                v-if="chartNum === 1"
                class="h-100"
                id="stoch-chart-div"
                style="width: 100%; position: relative; left: 0; top: -20px;"
              >
                <svg id="svg-stoch"></svg>
              </div>
              <div
                v-else-if="chartNum === 2"
                class="h-100"
                id="stoch-chart-div-2"
                style="width: 100%; position: relative; left: 0; top: -20px;"
              >
                <svg id="svg-stoch-2"></svg>
              </div>
              <div
                v-else-if="chartNum === 3"
                class="h-100"
                id="stoch-chart-div-3"
                style="width: 100%; position: relative; left: 0; top: -20px;"
              >
                <svg id="svg-stoch-3"></svg>
              </div>
              <div
                v-else-if="chartNum === 4"
                class="h-100"
                id="stoch-chart-div-4"
                style="width: 100%; position: relative; left: 0; top: -20px;"
              >
                <svg id="svg-stoch-4"></svg>
              </div>
              <div
                v-else-if="chartNum === 5"
                class="h-100"
                id="stoch-chart-div-5"
                style="width: 100%; position: relative; left: 0; top: -20px;"
              >
                <svg id="svg-stoch-5"></svg>
              </div>
              <div
                v-else-if="chartNum === 6"
                class="h-100"
                id="stoch-chart-div-6"
                style="width: 100%; position: relative; left: 0; top: -20px;"
              >
                <svg id="svg-stoch-6"></svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import HoverMultiSelection from "@/components/buttons/HoverMultiSelection.vue";
import IntervalsIndepComponent from "@/components/intervals/IntervalsIndep";
import PeriodsIndepComponent from "@/components/intervals/PeriodsIndep";
import TechnicalAnalysisInfo from "@/components/chartInfoOnHover/TechnicalAnalysisInfo";
import TermIntervals from "@/components/intervals/TermIntervals";
import { D3Chart } from "@/_core/charts/D3Chart";
import { timeCompare } from "@/_core/data/Advanced";
import { saveUserPreferences } from "@/_core/data/SaveToDB";
import {
  candleAlpha,
  colorDarkExpoAlpha,
  colorDarkHedge,
  colorExpo,
  colorExpoAlpha,
  colorExpoAlpha2,
  colorFwd,
  colorHedge,
  colorHedgeAlpha,
  colorNet,
  colorRed,
  currencyFormat,
  dateFormat,
  dnCandles,
  dnCandlesAlpha,
  fibonacciAreaSelection,
  fibonacciColorSelection,
  formatPercent,
  prefixOptions,
  tDaysM,
  tDaysW,
  textactive,
  textinactive,
  tFormat,
  titleTexts,
} from "@/_core/_helpers/_parametric_tools";
import {
  additionalYSpace,
  dateRangeToString,
  lengthByDate,
  noLiquidity,
} from "@/_core/_helpers/_helpers";
import {
  inRange,
  TABars,
  TACandles,
  TAHover,
  TACandlesZoomEnd,
} from "@/_core/charts/TechnicalAnalysis";
import { RSIHover, RSIZoomEnd } from "@/_core/charts/TechnicalAnalysisRSI";
import { MACDHover, MACDZoomEnd } from "@/_core/charts/TechnicalAnalysisMACD";
import {
  STOCHHover,
  STOCHZoomEnd,
} from "@/_core/charts/TechnicalAnalysisSTOCH";
import { getDefaultMarketsPreferences } from "@/_core/data/Markets";
import trendLine from "@/assets/images/svgTrendLine.vue";
import {
  curveMonotoneX,
  format,
  max,
  min,
  select,
  symbol,
  symbolSquare,
  timeFormat,
  zoomIdentity,
} from "d3";
import QSLoading from "@/components/QSLoading.vue";

export default {
  name: "TechnicalAnalysis",
  props: {
    chartDataRaw: { required: true, default: () => [] },
    chartName: { required: false, default: "" },
    chartNum: { required: false, default: 1 },
    colorTheme: { required: true, type: Boolean, default: true },
    commodityStringLong: { required: false, default: "N.A" },
    dataReady: { required: true },
    isCurrency: { required: false, type: Boolean, default: true },
    nSelected: { required: false, default: 0 },
    processData: { required: true },
    renderSignal: { required: false, default: 0 },
    selectedCurrency: { required: true, default: "na" },
    commodityName: { required: false, default: "na" },
    showLoading: { required: true },
    small: { required: false, type: Boolean, default: false },
    spot: { required: false, default: null },
    verySmall: { required: false, type: Boolean, default: false },
    isDynamicSize: { required: false, type: Boolean, default: false },
  },
  components: {
    Column,
    DataTable,
    HoverMultiSelection,
    IntervalsIndepComponent,
    PeriodsIndepComponent,
    QSLoading,
    TechnicalAnalysisInfo,
    TermIntervals,
    trendLine,
  },
  data() {
    return {
      additionalDates: [],
      bandWidth: 0,
      barWidth: 0.6,
      barWidthMACD: 0.6,
      candleData: [],
      candleWidth: 0,
      chartBodyMACD: [],
      chartBodyRSI: [],
      chartBodySTOCH: [],
      chartBodyTA: [],
      currencyFormat: currencyFormat,
      D3Chart: null,
      D3ChartMACD: null,
      D3ChartRSI: null,
      D3ChartSTOCH: null,
      dAdditionalDates: [],
      dateFormat: dateFormat,
      dateTitle: "Date:",
      dChartDataRaw: [],
      expandLeft: false,
      expandRight: false,
      externalZoom: false,
      fibonacci: null,
      fiboTEData: [],
      fiboTerm: "medium",
      fiboTrendData: [],
      filteredData: [],
      fRetracement: {
        short: { idx1: 0, idx2: 0, p0: 0, p1: 0, p2: 0, o0: 0, o1: 0, o2: 0 },
        medium: { idx1: 0, idx2: 0, p0: 0, p1: 0, p2: 0, o0: 0, o1: 0, o2: 0 },
        long: { idx1: 0, idx2: 0, p0: 0, p1: 0, p2: 0, o0: 0, o1: 0, o2: 0 },
      },
      formatPercent: formatPercent,
      hideLeft: false,
      hideRight: false,
      interval: "day",
      isCandles: null,
      isSmall: true,
      keepDateInterval: true,
      logo: require("@/assets/images/symbol_blue.svg"),
      ma1: 20,
      ma2: 40,
      ma3: 100,
      mAdditionalDates: [],
      mChartDataRaw: [],
      md1: 12,
      md2: 26,
      md3: 9,
      minMaxYAxis: [0, 1],
      minMaxYAxisOld: [0, 1],
      options: [
        { label: "1M", value: "1M" },
        { label: "3M", value: "3M" },
        { label: "6M", value: "6M" },
        { label: "1Y", value: "1Y" },
        { label: "2Y", value: "2Y" },
        { label: "3Y", value: "3Y" },
        { label: "5Y", value: "5Y" },
        { label: "10Y", value: "10Y" },
        { label: "20Y", value: "20Y" },
      ],
      pickedDateInterval: "1Y",
      prefixOptions: prefixOptions,
      priceLegend: {
        date: "...",
        open: "...",
        high: "...",
        low: "...",
        close: "...",
        change: "...",
      },
      pxPercent: [0, 0.236, 0.382, 0.5, 0.618, 0.786, 1],
      resizeObserver: null,
      rsi: 14,
      selectedDays: 261,
      show20ma: this.$store.state.user_preferences.all.items.markets_choices
        .show20ma,
      show3ma: this.$store.state.user_preferences.all.items.markets_choices
        .show3ma,
      show40ma: this.$store.state.user_preferences.all.items.markets_choices
        .show40ma,
      showBoll: this.$store.state.user_preferences.all.items.markets_choices
        .showBoll,
      showFibo: this.$store.state.user_preferences.all.items.markets_choices
        .showFibo,
      showFiboE: this.$store.state.user_preferences.all.items.markets_choices
        .showFiboE,
      showFiboR: this.$store.state.user_preferences.all.items.markets_choices
        .showFiboR,
      showFiboTE: this.$store.state.user_preferences.all.items.markets_choices
        .showFiboTE,
      showMACD: this.$store.state.user_preferences.all.items.markets_choices
        .showMACD,
      showPivots: false,
      showRSI: this.$store.state.user_preferences.all.items.markets_choices
        .showRSI,
      showSTOCH: this.$store.state.user_preferences.all.items.markets_choices
        .showSTOCH,
      stoch1: 14,
      stoch2: 3,
      svgNode: null,
      svgNodeMACD: null,
      svgNodeRSI: null,
      svgNodeSTOCH: null,
      tDaysM: tDaysM,
      tDaysW: tDaysW,
      tFormat: tFormat,
      title: "daily",
      titleTexts: titleTexts,
      transform: null,
      trendLineData: this.$store.state.user_preferences.all.items
        .markets_choices.trendLineData,
      wAdditionalDates: [],
      wChartDataRaw: [],
      xt: null,
      zoomMACD: null,
      zoomRSI: null,
      zoomSTOCH: null,
      zoomTA: null,
    };
  },
  created() {
    this.markets_preferences = getDefaultMarketsPreferences(this)["choices"];
    this.dAdditionalDates = this.processData.createNDays(new Date(), 40);
    let dat = new Date();
    let day = dat.getDate();
    let days = day === 0 ? 1 : day;
    dat.setDate(days);
    this.wAdditionalDates = this.processData.createNWeeks(dat, 8);
    dat = new Date();
    day = dat.getDate();
    dat.setDate(dat.getDate() - dat.getDate() + 1);
    this.mAdditionalDates = this.processData.createNMonths(dat, 4);
    if (this.trendLineData === undefined) {
      this.trendLineData = [];
    }
  },
  mounted() {
    // ===== create initial charts instances =====
    let divField =
      this.chartNum === 1
        ? ""
        : this.chartNum === 2
        ? "-2"
        : this.chartNum === 3
        ? "-3"
        : this.chartNum === 4
        ? "-4"
        : this.chartNum === 5
        ? "-5"
        : "-6";
    this.D3Chart = new D3Chart(
      "technical-analysis-chart-div" + divField,
      "svg-technical-analysis" + divField,
    );
    this.D3ChartRSI = new D3Chart(
      "rsi-chart-div" + divField,
      "svg-rsi" + divField,
    );
    this.D3ChartMACD = new D3Chart(
      "macd-chart-div" + divField,
      "svg-macd" + divField,
    );
    this.D3ChartSTOCH = new D3Chart(
      "stoch-chart-div" + divField,
      "svg-stoch" + divField,
    );

    if (this.chartDataRaw.length > 0) {
      this.DWMdataPrep();
    }

    if (this.small === true) {
      this.selectedDays = 195;
      this.pickedDateInterval = "6M";
      this.showRSI = false;
      this.showMACD = false;
      this.showSTOCH = false;
    }

    // Keep a reference so beforeDestroy can actually remove it
    this.onWindowResize = () => {
      this.callWidth();
      this.checkDivWidth();
    };
    window.addEventListener("resize", this.onWindowResize);

    // Add ResizeObserver for container-specific resizes.
    // Skips the initial notification (the data watchers already draw) and
    // redraws at most once per frame, only when the size really changed.
    this.lastChartSize = null;
    this.resizeObserver = new ResizeObserver((entries) => {
      const { width, height } = entries[0].contentRect;
      const size = `${width}x${height}`;
      const isFirst = this.lastChartSize === null;
      if (size === this.lastChartSize) {
        return;
      }
      this.lastChartSize = size;
      if (isFirst || this.candleData.length === 0) {
        return;
      }
      cancelAnimationFrame(this.resizeFrame);
      this.resizeFrame = requestAnimationFrame(() => {
        this.createAllCharts(true);
      });
    });
    this.resizeObserver.observe(
      document.getElementById("technical-analysis-chart-div" + divField),
    );
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onWindowResize);
    cancelAnimationFrame(this.resizeFrame);

    // Clean up the observer
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  computed: {
    pivots() {
      if (this.candleData.length < 4) {
        return null;
      }
      let nLen = this.candleData.length - 2;
      let pivot =
        (this.candleData[nLen].high +
          this.candleData[nLen].low +
          this.candleData[nLen].close) /
        3;
      let priceRange = this.candleData[nLen].high - this.candleData[nLen].low;
      let support1 = 2 * pivot - this.candleData[nLen].high;
      let support2 = pivot - priceRange;
      let resistance1 = 2 * pivot - this.candleData[nLen].low;
      let resistance2 = pivot + priceRange;
      return [
        { name: "2nd Resistance", value: resistance2 },
        { name: "1st Resistance", value: resistance1 },
        { name: "Pivot", value: pivot },
        { name: "1st Support", value: support1 },
        { name: "2nd Support", value: support2 },
      ];
    },
    nCharts() {
      return !!this.showRSI + !!this.showMACD + !!this.showSTOCH;
    },
    chartDateRange() {
      if (this.filteredData.length === 0) {
        return timeFormat("%b %d, %Y")(new Date());
      } else {
        return dateRangeToString(
          this.filteredData[0].date,
          this.filteredData[this.filteredData.length - 1].date,
          true,
          "\u2192",
        );
      }
    },
  },
  watch: {
    colorTheme() {
      if (this.chartDataRaw.length > 0 && this.showLoading === false) {
        this.createAllCharts();
      }
    },
    renderSignal() {
      this.createCandleChart();
      this.hoverCandle();
    },
    spot(val) {
      if (!("rescaleX" in (this.transform || {}))) {
        return;
      }
      if (
        val !== undefined &&
        val !== null &&
        val !== 0 &&
        Number.isFinite(val) &&
        this.chartDataRaw.length > 0 &&
        this.showLoading === false
      ) {
        if (this.dChartDataRaw.length > 0) {
          this.includeSpot("dChartDataRaw");
          this.getTAForSpot("dChartDataRaw");
        }
        if (this.wChartDataRaw.length > 0) {
          this.includeSpot("wChartDataRaw");
          this.getTAForSpot("wChartDataRaw");
        }
        if (this.mChartDataRaw.length > 0) {
          this.includeSpot("mChartDataRaw");
          this.getTAForSpot("mChartDataRaw");
        }
        this.checkDivWidth();
        TACandlesZoomEnd(
          this.transform,
          this.transform.rescaleX(this.svgNode.x),
          this.svgNode.y,
          this.filteredData,
          this,
          this.spot,
          this.svgNode.lastYTooltip,
          colorExpo(this.colorTheme),
          dnCandles(this.colorTheme),
          candleAlpha(this.colorTheme),
          candleAlpha(this.colorTheme),
          null,
          null,
          0.7,
        );
        if (this.showRSI) {
          RSIZoomEnd(
            this.transform,
            this.transform.rescaleX(this.svgNodeRSI.x),
            this.svgNodeRSI.y,
            this.filteredData,
            this,
            this.svgNodeRSI.lastYTooltip,
            this.filteredData[this.filteredData.length - 1].rsi,
          );
        }
        if (this.showMACD) {
          MACDZoomEnd(
            this.transform,
            this.transform.rescaleX(this.svgNodeMACD.x),
            this.svgNodeMACD.y,
            this.filteredData,
            this,
            this.barWidth,
            this.filteredData.at(-1).macd,
            this.svgNodeMACD.lastYTooltip,
          );
        }
        if (this.showSTOCH) {
          STOCHZoomEnd(
            this.transform,
            this.transform.rescaleX(this.svgNodeSTOCH.x),
            this.svgNodeSTOCH.y,
            this.filteredData,
            this,
            this.svgNodeSTOCH.lastYTooltip,
            this.filteredData.at(-1).stochPK,
          );
        }
      }
    },
    dataReady() {
      this.isCandles = null;
      this.scheduleDataPrep();
    },
    showLoading() {
      if (this.showLoading) {
        this.deleteChart();
      }
    },
    trendLineData() {
      this.updateTrendLine();
    },
    chartDataRaw() {
      this.scheduleDataPrep();
    },
  },
  filters: {
    priceFormat: function(val) {
      return val === null || val === 0 ? "-" : format(",.4r")(val);
    },
    percFormat: function(val) {
      return val === null || val === 0 ? "-" : formatPercent(val);
    },
    dateFormat: function(val) {
      return val === null ||
        val === "" ||
        val === 0 ||
        +val < +new Date(1980, 1, 1)
        ? "-"
        : timeFormat("%d %b %y")(val);
    },
  },
  methods: {
    // The parent sets chartDataRaw and dataReady in the same tick; coalesce
    // both watchers into a single prep + draw, after the DOM has updated.
    scheduleDataPrep() {
      if (this.dataPrepPending) {
        return;
      }
      this.dataPrepPending = true;
      this.$nextTick(() => {
        this.dataPrepPending = false;
        if (this.chartDataRaw.length > 0) {
          this.checkDivWidth();
          this.keepDateInterval = true;
          this.DWMdataPrep();
          this.checkDivWidth();
        } else {
          this.deleteChart();
        }
      });
    },
    checkDivWidth() {
      const refName = `containerDiv${this.chartName}`;
      if (this.$refs[refName]) {
        const divWidth = this.$refs[refName].offsetWidth;
        this.isSmall = divWidth <= 444;
      } else {
        // console.warn(`Ref ${refName} not defined`);
        this.isSmall = false;
      }
    },
    deleteChart() {
      let divField =
        this.chartNum === 1
          ? ""
          : this.chartNum === 2
          ? "-2"
          : this.chartNum === 3
          ? "-3"
          : this.chartNum === 4
          ? "-4"
          : this.chartNum === 5
          ? "-5"
          : "-6";
      select("#technical-analysis-chart-div" + divField)
        .selectAll(".tooltip")
        .remove();
      select("#technical-analysis-chart-div" + divField)
        .select("svg > *")
        .remove();
      select("#rsi-chart-div" + divField)
        .selectAll(".tooltip")
        .remove();
      select("#rsi-chart-div" + divField)
        .select("svg > *")
        .remove();
      select("#macd-chart-div" + divField)
        .selectAll(".tooltip")
        .remove();
      select("#macd-chart-div" + divField)
        .select("svg > *")
        .remove();
      select("#stoch-chart-div" + divField)
        .selectAll(".tooltip")
        .remove();
      select("#stoch-chart-div" + divField)
        .select("svg > *")
        .remove();
    },
    getTAForSpot(fieldName) {
      let len = this[fieldName].length;
      let sliced = this[fieldName].slice(len - this.ma1);
      let ma1 =
        sliced.map((d) => d.close).reduce((a, b) => a + b, 0) / this.ma1;
      sliced = this[fieldName].slice(len - this.ma2);
      let ma2 =
        sliced.map((d) => d.close).reduce((a, b) => a + b, 0) / this.ma2;
      sliced = this[fieldName].slice(len - this.ma3);
      let ma3 =
        sliced.map((d) => d.close).reduce((a, b) => a + b, 0) / this.ma3;
      let boll = this.processData.bollinger(this[fieldName], 20, 0);
      let rsi = this.processData.rsi(this[fieldName], this.rsi);
      let macd = this.processData.macd(
        this[fieldName].map((d) => d.close),
        this.md1,
        this.md2,
        this.md3,
      );
      let stoch = this.processData.stoch(
        this[fieldName],
        this.stoch1,
        this.stoch2,
      );

      this[fieldName][len - 1].ma1 = ma1;
      this[fieldName][len - 1].ma2 = ma2;
      this[fieldName][len - 1].ma3 = ma3;
      this[fieldName][len - 1].bband_ma = boll[len - 1]["bband_ma"];
      this[fieldName][len - 1].bband_l1 = boll[len - 1]["bband_l1"];
      this[fieldName][len - 1].bband_l2 = boll[len - 1]["bband_l2"];
      this[fieldName][len - 1].bband_u1 = boll[len - 1]["bband_u1"];
      this[fieldName][len - 1].bband_u2 = boll[len - 1]["bband_u2"];
      this[fieldName][len - 1].rsi = rsi ? rsi[len - 1] : 0;
      this[fieldName][len - 1].macd = macd ? macd[len - 1].macd : 0;
      this[fieldName][len - 1].macdSignal = macd ? macd[len - 1].signal : 0;
      this[fieldName][len - 1].macdHist = macd ? macd[len - 1].histogram : 0;
      this[fieldName][len - 1].stochPK = stoch ? stoch[len - 1].pK : 0;
      this[fieldName][len - 1].stochPD = stoch ? stoch[len - 1].pD : 0;
    },
    includeSpot(fieldName) {
      if (this.spot != null && this.spot !== 0 && Number.isFinite(this.spot)) {
        let nLen = this[fieldName].length - 1;
        this[fieldName][nLen].high = Math.max(
          this.spot,
          this[fieldName][nLen].high,
        );
        this[fieldName][nLen].low = Math.min(
          this.spot,
          this[fieldName][nLen].low,
        );
        this[fieldName][nLen].close = this.spot;
      }
    },
    onChangeDWMSmall(item) {
      this.onChangeDWM(item.value);
    },
    onChangeDWM(item) {
      this.keepDateInterval = true;
      this.interval = item;
      this.dateFormat = this.tFormat[item];
      this.dateTitle = this.prefixOptions[item];
      this.title = this.titleTexts[item];
      this.sliceData(this.pickedDateInterval);
    },
    onChangeIntervalSmall(item) {
      this.onChangeInterval(item.value);
    },
    // ===== Changing time intervals  =====
    onChangeInterval(item) {
      this.pickedDateInterval = item;
      this.keepDateInterval = true;
      this.sliceData(item);
    },
    onUserCandlesLineSelect() {
      this.isCandles = !this.isCandles;
      if (this.isCandles) {
        this.svgNode["stick" + this.chartName].style("opacity", 1);
        this.svgNode["candle" + this.chartName].style("opacity", 1);
        this.svgNode["upperLineTA" + this.chartName].style("opacity", 0);
        this.svgNode["lowerLineTA" + this.chartName].style("opacity", 0);
        this.svgNode["areaTA" + this.chartName].style("opacity", 0);
      } else {
        this.svgNode["stick" + this.chartName].style("opacity", 0);
        this.svgNode["candle" + this.chartName].style("opacity", 0);
        this.svgNode["upperLineTA" + this.chartName].style("opacity", 1);
        this.svgNode["lowerLineTA" + this.chartName].style("opacity", 1);
        this.svgNode["areaTA" + this.chartName].style("opacity", 1);
      }
    },
    showHideMA20() {
      this.show20ma = !this.show20ma;
      this.$store.state.user_preferences.all.items.markets_choices.show20ma = this.show20ma;
      saveUserPreferences(this);
      if (this.show20ma) {
        this.svgNode["lineMA20" + this.chartName].style("opacity", 1);
      } else {
        this.svgNode["lineMA20" + this.chartName].style("opacity", 0);
      }
    },
    showHideMA40() {
      this.show40ma = !this.show40ma;
      this.$store.state.user_preferences.all.items.markets_choices.show40ma = this.show40ma;
      saveUserPreferences(this);
      if (this.show40ma) {
        this.svgNode["lineMA40" + this.chartName].style("opacity", 1);
      } else {
        this.svgNode["lineMA40" + this.chartName].style("opacity", 0);
      }
    },
    showHideMA3() {
      this.show3ma = !this.show3ma;
      this.$store.state.user_preferences.all.items.markets_choices.show3ma = this.show3ma;
      saveUserPreferences(this);
      if (this.show3ma) {
        this.svgNode["lineMA3" + this.chartName].style("opacity", 1);
      } else {
        this.svgNode["lineMA3" + this.chartName].style("opacity", 0);
      }
    },
    showHideBoll() {
      this.showBoll = !this.showBoll;
      this.$store.state.user_preferences.all.items.markets_choices.showBoll = this.showBoll;
      saveUserPreferences(this);
      if (this.showBoll) {
        this.svgNode["upperLineBoll" + this.chartName].style("opacity", 1);
        this.svgNode["upperLineBoll2" + this.chartName].style("opacity", 1);
        this.svgNode["lowerLineBoll" + this.chartName].style("opacity", 1);
        this.svgNode["lowerLineBoll2" + this.chartName].style("opacity", 1);
        this.svgNode["areaBoll2" + this.chartName].style("opacity", 1);
        this.svgNode["lineBoll" + this.chartName].style("opacity", 1);
      } else {
        this.svgNode["upperLineBoll" + this.chartName].style("opacity", 0);
        this.svgNode["upperLineBoll2" + this.chartName].style("opacity", 0);
        this.svgNode["lowerLineBoll" + this.chartName].style("opacity", 0);
        this.svgNode["lowerLineBoll2" + this.chartName].style("opacity", 0);
        this.svgNode["areaBoll2" + this.chartName].style("opacity", 0);
        this.svgNode["lineBoll" + this.chartName].style("opacity", 0);
      }
    },
    // ===== Processing and showing moving averages and RSI  =====
    onUserMA1Change() {
      this.keepDateInterval = true;
      this.wChartDataRaw = Object.freeze(this.updateMA1(this.wChartDataRaw));
      this.mChartDataRaw = Object.freeze(this.updateMA1(this.mChartDataRaw));
      this.dChartDataRaw = Object.freeze(this.updateMA1(this.dChartDataRaw));
      this.sliceData(this.pickedDateInterval);
    },
    onUserMA2Change() {
      this.keepDateInterval = true;
      this.wChartDataRaw = Object.freeze(this.updateMA2(this.wChartDataRaw));
      this.mChartDataRaw = Object.freeze(this.updateMA2(this.mChartDataRaw));
      this.dChartDataRaw = Object.freeze(this.updateMA2(this.dChartDataRaw));
      this.sliceData(this.pickedDateInterval);
    },
    onUserMA3Change() {
      this.keepDateInterval = true;
      this.wChartDataRaw = Object.freeze(this.updateMA3(this.wChartDataRaw));
      this.mChartDataRaw = Object.freeze(this.updateMA3(this.mChartDataRaw));
      this.dChartDataRaw = Object.freeze(this.updateMA3(this.dChartDataRaw));
      this.sliceData(this.pickedDateInterval);
    },
    createAllCharts(calculate = false) {
      this.createCandleChart(calculate);
      this.createRSIChart();
      this.createMACDChart();
      this.createSTOCHChart();

      this.hoverRSI();
      this.hoverMACD();
      this.hoverSTOCH();
      this.hoverCandle();
    },
    showHideRSI() {
      this.showRSI = !this.showRSI;
      this.$store.state.user_preferences.all.items.markets_choices.showRSI = this.showRSI;
      saveUserPreferences(this);
      this.keepDateInterval = true;
      setTimeout(() => {
        this.createAllCharts(true);
      }, 100);
    },
    showHideMACD() {
      this.showMACD = !this.showMACD;
      this.$store.state.user_preferences.all.items.markets_choices.showMACD = this.showMACD;
      saveUserPreferences(this);
      this.keepDateInterval = true;
      setTimeout(() => {
        this.createAllCharts(true);
      }, 100);
    },
    showHideSTOCH() {
      this.showSTOCH = !this.showSTOCH;
      this.$store.state.user_preferences.all.items.markets_choices.showSTOCH = this.showSTOCH;
      saveUserPreferences(this);
      this.keepDateInterval = true;
      setTimeout(() => {
        this.createAllCharts(true);
      }, 100);
    },
    showHidePivots() {
      this.showPivots = !this.showPivots;
    },
    onUserRSIChange() {
      this.keepDateInterval = true;
      this.$store.state.user_preferences.all.items.markets_choices.showRSI = !this
        .showRSI;
      saveUserPreferences(this);
      this.wChartDataRaw = Object.freeze(this.updateRSI(this.wChartDataRaw));
      this.mChartDataRaw = Object.freeze(this.updateRSI(this.mChartDataRaw));
      this.dChartDataRaw = Object.freeze(this.updateRSI(this.dChartDataRaw));
      this.sliceData(this.pickedDateInterval);
    },
    onUserMACDChange() {
      this.keepDateInterval = true;
      this.$store.state.user_preferences.all.items.markets_choices.showMACD = !this
        .showMACD;
      saveUserPreferences(this);
      this.wChartDataRaw = Object.freeze(this.updateMACD(this.wChartDataRaw));
      this.mChartDataRaw = Object.freeze(this.updateMACD(this.mChartDataRaw));
      this.dChartDataRaw = Object.freeze(this.updateMACD(this.dChartDataRaw));
      this.sliceData(this.pickedDateInterval);
    },
    onUserSTOCHChange() {
      this.keepDateInterval = true;
      this.$store.state.user_preferences.all.items.markets_choices.showSTOCH = !this
        .showSTOCH;
      saveUserPreferences(this);
      this.wChartDataRaw = Object.freeze(this.updateSTOCH(this.wChartDataRaw));
      this.mChartDataRaw = Object.freeze(this.updateSTOCH(this.mChartDataRaw));
      this.dChartDataRaw = Object.freeze(this.updateSTOCH(this.dChartDataRaw));
      this.sliceData(this.pickedDateInterval);
    },
    showHideFibo() {
      this.showFibo = !this.showFibo;
      this.$store.state.user_preferences.all.items.markets_choices.showFibo = this.showFibo;
      saveUserPreferences(this);
      if (
        this.showFibo &&
        this.showFiboR === false &&
        this.showFiboE === false &&
        this.showFiboTE === false
      ) {
        this.$store.state.user_preferences.all.items.markets_choices.showFiboR = this.showFiboR;
        this.showFiboR = true;
      }
      this.keepDateInterval = true;
      this.createCandleChart(false);
      this.hoverCandle();
      saveUserPreferences(this);
    },
    onUserShowHideFiboR() {
      this.showFiboR = !this.showFiboR;
      this.$store.state.user_preferences.all.items.markets_choices.showFiboR = this.showFiboR;
      if (
        this.showFiboR === false &&
        this.showFiboE === false &&
        this.showFiboTE === false
      ) {
        this.showFibo = false;
        this.$store.state.user_preferences.all.items.markets_choices.showFibo = this.showFibo;
      }
      this.keepDateInterval = true;
      this.createCandleChart(false);
      this.hoverCandle();
      saveUserPreferences(this);
    },
    onUserShowHideFiboE() {
      this.showFiboE = !this.showFiboE;
      this.$store.state.user_preferences.all.items.markets_choices.showFiboE = this.showFiboE;
      if (
        this.showFiboR === false &&
        this.showFiboE === false &&
        this.showFiboTE === false
      ) {
        this.showFibo = false;
        this.$store.state.user_preferences.all.items.markets_choices.showFibo = this.showFibo;
      }
      this.keepDateInterval = true;
      this.createCandleChart(false);
      this.hoverCandle();
      saveUserPreferences(this);
    },
    onUserShowHideFiboTE() {
      this.showFiboTE = !this.showFiboTE;
      this.$store.state.user_preferences.all.items.markets_choices.showFiboTE = this.showFiboTE;
      if (
        this.showFiboR === false &&
        this.showFiboE === false &&
        this.showFiboTE === false
      ) {
        this.showFibo = false;
        this.$store.state.user_preferences.all.items.markets_choices.showFibo = this.showFibo;
      }
      this.keepDateInterval = true;
      this.createCandleChart(false);
      this.hoverCandle();
      saveUserPreferences(this);
    },
    onChangeFiboTerm(term) {
      this.fiboTerm = term;
      this.keepDateInterval = true;
      this.createCandleChart(false);
      this.hoverCandle();
    },
    onUserDecreaseFibonacci() {
      this.fibonacci[this.fiboTerm].num = Math.min(
        this.fibonacci[this.fiboTerm].minMax.length,
        this.fibonacci[this.fiboTerm].num + 1,
      );
      this.keepDateInterval = true;
      this.createCandleChart(false);
      this.hoverCandle();
    },
    onUserIncreaseFibonacci() {
      this.fibonacci[this.fiboTerm].num = Math.max(
        1,
        this.fibonacci[this.fiboTerm].num - 1,
      );
      this.keepDateInterval = true;
      this.createCandleChart(false);
      this.hoverCandle();
    },
    updateTrendLine() {
      this.$store.state.user_preferences.all.items.markets_choices.trendLineData = this.trendLineData;
      saveUserPreferences(this);
    },
    // ========= Getting all data from markets commodities component =======
    DWMdataPrep() {
      // Only the daily series is built up front; weekly/monthly are built
      // lazily by ensureIntervalData() when the user selects them.
      // Arrays are frozen so Vue does not make thousands of rows reactive.
      this.wChartDataRaw = [];
      this.mChartDataRaw = [];
      this.dChartDataRaw = Object.freeze(
        this.dataPrep(this.chartDataRaw, "day"),
      );
      // Previously the weekly pass always ran first and reset showFibo;
      // keep that behaviour now that the weekly pass is lazy.
      this.showFibo = false;
      if (this.isCandles == null) {
        this.isCandles = noLiquidity(this.dChartDataRaw);
      }
      this.sliceData(this.pickedDateInterval);
    },
    ensureIntervalData() {
      if (this.interval === "week" && this.wChartDataRaw.length === 0) {
        this.wChartDataRaw = Object.freeze(
          this.dataPrep(this.chartDataRaw, "week"),
        );
      } else if (this.interval === "month" && this.mChartDataRaw.length === 0) {
        this.mChartDataRaw = Object.freeze(
          this.dataPrep(this.chartDataRaw, "month"),
        );
      }
    },
    dataPrep(data, term) {
      if (this.spot !== null) {
        this.includeSpot("chartDataRaw");
      }
      let newData = [];
      if (term !== "day") {
        newData = this.processData.ohlcNest(data, term);
      } else {
        newData = data;
      }
      let closeArr = newData.map((d) => d.close);
      let ma20 = this.processData.movingAverage(closeArr, this.ma1, 0);
      let ma40 = this.processData.movingAverage(closeArr, this.ma2, 0);
      let ma3 = this.processData.movingAverage(closeArr, this.ma3, 0);
      let boll = this.processData.bollinger(newData, 20, 0);
      let rsi = this.processData.rsi(newData, this.rsi);
      let macd = this.processData.macd(closeArr, this.md1, this.md2, this.md3);
      let stoch = this.processData.stoch(newData, this.stoch1, this.stoch2);
      let keys = Object.keys(newData[0]);
      // Fibonacci levels come from the daily series only; weekly/monthly
      // are built lazily and must not reset them.
      if (term === "day") {
        if (
          keys.includes("find_max_long") &&
          keys.includes("find_min_long") &&
          keys.includes("find_max_medium") &&
          keys.includes("find_min_medium") &&
          keys.includes("find_max_short") &&
          keys.includes("find_min_short")
        ) {
          this.fibonacci = this.processData.fibonacciMinMax(newData);
          if (
            this.fibonacci.short.minMax.length === 0 ||
            this.fibonacci.medium.minMax.length === 0 ||
            this.fibonacci.long.minMax.length === 0
          ) {
            this.fibonacci = null;
            this.showFibo = false;
          }
        } else {
          this.fibonacci = null;
          this.showFibo = false;
        }
      }
      newData = newData.map((d, i) => ({
        id: +d["date"],
        date: d["date"],
        open: d["open"],
        high: d["high"],
        low: d["low"],
        close: d["close"],
        ma20: ma20[i],
        ma40: ma40[i],
        ma3: ma3[i],
        bband_ma: boll[i]["bband_ma"],
        bband_l1: boll[i]["bband_l1"],
        bband_l2: boll[i]["bband_l2"],
        bband_u1: boll[i]["bband_u1"],
        bband_u2: boll[i]["bband_u2"],
        rsi: rsi ? rsi[i] : 0,
        macd: macd ? macd[i].macd : 0,
        macdSignal: macd ? macd[i].signal : 0,
        macdHist: macd ? macd[i].histogram : 0,
        stochPK: stoch ? stoch[i].pK : 0,
        stochPD: stoch ? stoch[i].pD : 0,
      }));
      return newData;
    },
    // ========== Moving average for technical analysis (20) ============
    updateMA1(data) {
      let newData = [];
      let ma20 = this.processData.movingAverage(
        data.map(function(d) {
          return d["close"];
        }),
        this.ma1,
        0,
      );
      newData = data.map((d, i) => ({
        date: d["date"],
        open: d["open"],
        high: d["high"],
        low: d["low"],
        close: d["close"],
        ma20: ma20[i],
        ma40: d["ma40"],
        ma3: d["ma3"],
        bband_ma: d["bband_ma"],
        bband_l1: d["bband_l1"],
        bband_l2: d["bband_l2"],
        bband_u1: d["bband_u1"],
        bband_u2: d["bband_u2"],
        rsi: d["rsi"],
        macd: d["macd"],
        macdSignal: d["macdSignal"],
        macdHist: d["macdHist"],
        stochPK: d["stochPK"],
        stochPD: d["stochPD"],
      }));
      return newData;
    },
    // ========== Moving average for technical analysis (40) ============
    updateMA2(data) {
      let newData = [];
      let ma40 = this.processData.movingAverage(
        data.map(function(d) {
          return d["close"];
        }),
        this.ma2,
        0,
      );
      newData = data.map((d, i) => ({
        date: d["date"],
        open: d["open"],
        high: d["high"],
        low: d["low"],
        close: d["close"],
        ma20: d["ma20"],
        ma40: ma40[i],
        ma3: d["ma3"],
        bband_ma: d["bband_ma"],
        bband_l1: d["bband_l1"],
        bband_l2: d["bband_l2"],
        bband_u1: d["bband_u1"],
        bband_u2: d["bband_u2"],
        rsi: d["rsi"],
        macd: d["macd"],
        macdSignal: d["macdSignal"],
        macdHist: d["macdHist"],
        stochPK: d["stochPK"],
        stochPD: d["stochPD"],
      }));
      return newData;
    },
    // ========== Moving average for technical analysis (40) ============
    updateMA3(data) {
      let newData = [];
      let ma3 = this.processData.movingAverage(
        data.map(function(d) {
          return d["close"];
        }),
        this.ma3,
        0,
      );
      newData = data.map((d, i) => ({
        date: d["date"],
        open: d["open"],
        high: d["high"],
        low: d["low"],
        close: d["close"],
        ma20: d["ma20"],
        ma40: d["ma40"],
        ma3: ma3[i],
        bband_ma: d["bband_ma"],
        bband_l1: d["bband_l1"],
        bband_l2: d["bband_l2"],
        bband_u1: d["bband_u1"],
        bband_u2: d["bband_u2"],
        rsi: d["rsi"],
        macd: d["macd"],
        macdSignal: d["macdSignal"],
        macdHist: d["macdHist"],
        stochPK: d["stochPK"],
        stochPD: d["stochPD"],
      }));
      return newData;
    },
    // ========== RSI for technical analysis ============
    updateRSI(data) {
      let newData = [];
      let rsi = this.processData.rsi(data, this.rsi);
      newData = data.map((d, i) => ({
        date: d["date"],
        open: d["open"],
        high: d["high"],
        low: d["low"],
        close: d["close"],
        ma20: d["ma20"],
        ma40: d["ma40"],
        ma3: d["ma3"],
        bband_ma: d["bband_ma"],
        bband_l1: d["bband_l1"],
        bband_l2: d["bband_l2"],
        bband_u1: d["bband_u1"],
        bband_u2: d["bband_u2"],
        rsi: rsi[i],
        macd: d["macd"],
        macdSignal: d["macdSignal"],
        macdHist: d["macdHist"],
        stochPK: d["stochPK"],
        stochPD: d["stochPD"],
      }));
      return newData;
    },
    // ========== MACD for technical analysis ============
    updateMACD(data) {
      let newData = [];
      let closeArr = data.map((d) => d.close);
      let macd = this.processData.macd(closeArr, this.md1, this.md2, this.md3);
      newData = data.map((d, i) => ({
        date: d["date"],
        open: d["open"],
        high: d["high"],
        low: d["low"],
        close: d["close"],
        ma20: d["ma20"],
        ma40: d["ma40"],
        ma3: d["ma3"],
        bband_ma: d["bband_ma"],
        bband_l1: d["bband_l1"],
        bband_l2: d["bband_l2"],
        bband_u1: d["bband_u1"],
        bband_u2: d["bband_u2"],
        rsi: d["rsi"],
        macd: macd[i].macd,
        macdSignal: macd[i].signal,
        macdHist: macd[i].histogram,
        stochPK: d["stochPK"],
        stochPD: d["stochPD"],
      }));
      return newData;
    },
    // ========== STOCHASTIC OSCILLATOR for technical analysis ============
    updateSTOCH(data) {
      let newData = [];
      let stoch = this.processData.stoch(data, this.stoch1, this.stoch2);
      newData = data.map((d, i) => ({
        date: d["date"],
        open: d["open"],
        high: d["high"],
        low: d["low"],
        close: d["close"],
        ma20: d["ma20"],
        ma40: d["ma40"],
        ma3: d["ma3"],
        bband_ma: d["bband_ma"],
        bband_l1: d["bband_l1"],
        bband_l2: d["bband_l2"],
        bband_u1: d["bband_u1"],
        bband_u2: d["bband_u2"],
        rsi: d["rsi"],
        macd: d["macd"],
        macdSignal: d["macdSignal"],
        macdHist: d["macdHist"],
        stochPK: stoch[i].pK,
        stochPD: stoch[i].pD,
      }));
      return newData;
    },
    // ========== Slicing for technical analysis ============
    sliceData(item) {
      this.ensureIntervalData();
      let data =
        this.interval === "day"
          ? this.dChartDataRaw
          : this.interval === "week"
          ? this.wChartDataRaw
          : this.mChartDataRaw;
      this.selectedDays =
        this.interval === "day"
          ? lengthByDate(
              item,
              this.dChartDataRaw.map((d) => d.date),
            )
          : this.interval === "week"
          ? this.tDaysW[item]
          : this.tDaysM[item];
      this.additionalDates =
        this.interval === "day"
          ? this.dAdditionalDates
          : this.interval === "week"
          ? this.wAdditionalDates
          : this.mAdditionalDates;
      // Rows are mutated below before the array is frozen and handed to Vue
      const candleData = data.map((d) => d); // this.processData.toSlice(data, this.selectedDays);
      let col;
      let _this = this;
      candleData.forEach(function(d, i) {
        d.zero = 0;
        d.rsi50 = 50;
        d.rsi70 = Math.min(70, d.rsi);
        d.rsi30 = Math.max(30, d.rsi);
        if (i === 0) {
          d.colorSel = "rgba(0, 0, 0, 0)";
          d.fillColorSel =
            d.macdHist >= 0
              ? colorExpo(_this.colorTheme)
              : dnCandles(_this.colorTheme);
        } else {
          d.colorSel = "rgba(0, 0, 0, 0)";
          col =
            d.macdHist <= 0
              ? d.macdHist <= candleData[i - 1].macdHist
                ? dnCandles(_this.colorTheme)
                : dnCandlesAlpha(_this.colorTheme)
              : d.macdHist >= candleData[i - 1].macdHist
              ? colorExpo(_this.colorTheme)
              : colorExpoAlpha2(_this.colorTheme);
          d.fillColorSel = col;
        }
      });
      this.candleData = Object.freeze(candleData);
      this.createAllCharts(true);
    },
    getMinMax(data) {
      let minMaxYAxis = this.processData.minMax(data, "high", "low");
      minMaxYAxis = this.processData.minMax(
        data,
        "close",
        "close",
        minMaxYAxis,
      );
      if (this.show20ma === true) {
        minMaxYAxis = this.processData.minMax(
          data,
          "ma20",
          "ma20",
          minMaxYAxis,
        );
      }
      if (this.show40ma === true) {
        minMaxYAxis = this.processData.minMax(
          data,
          "ma40",
          "ma40",
          minMaxYAxis,
        );
      }
      if (this.show3ma === true) {
        minMaxYAxis = this.processData.minMax(data, "ma3", "ma3", minMaxYAxis);
      }
      if (this.showBoll === true) {
        minMaxYAxis = this.processData.minMax(
          data,
          "bband_ma",
          "bband_ma",
          minMaxYAxis,
        );
        minMaxYAxis = this.processData.minMax(
          data,
          "bband_u2",
          "bband_l2",
          minMaxYAxis,
        );
      }
      if (this.showFibo) {
        minMaxYAxis = additionalYSpace(minMaxYAxis, 0.15);
      } else {
        minMaxYAxis = additionalYSpace(minMaxYAxis, 0.1);
      }
      return minMaxYAxis;
    },
    getMinMaxMACD(data) {
      let extYAxis = this.processData.minMax(data, "macd", "macd");
      extYAxis = this.processData.minMax(
        data,
        "macdSignal",
        "macdSignal",
        extYAxis,
      );
      extYAxis = this.processData.minMax(
        data,
        "macdHist",
        "macdHist",
        extYAxis,
      );
      return additionalYSpace(extYAxis, 0.15);
    },
    // ========== Create charts ============
    createCandleChart(calculate = false, spotUpdated = false) {
      if (this.candleData.length === 0) {
        return;
      }
      if (this.pickedDateInterval !== "-1") {
        this.selectedDays = lengthByDate(
          this.pickedDateInterval,
          this.candleData.map((d) => d.date),
        );
        let xMin = this.candleData[this.candleData.length - this.selectedDays]
          .date;
        let xMax = this.additionalDates[this.additionalDates.length - 1].date;
        let data = this.candleData.map((d) => d);
        this.filteredData = Object.freeze(
          data.filter(function(d) {
            return inRange(d.date, xMin, xMax);
          }),
        );
      } else if (calculate && "x" in this.svgNode) {
        let xt = this.transform.rescaleX(this.svgNode.x);
        let xMin = xt.invert(0);
        let xMax = xt.invert(this.svgNode.width);
        let data = this.candleData.map((d) => d);
        this.filteredData = Object.freeze(
          data.filter(function(d) {
            return inRange(d.date, xMin, xMax);
          }),
        );
        this.selectedDays = this.filteredData.length;
      }
      this.svgNode = this.D3Chart.setSVG(
        0.5,
        5,
        0.5,
        60,
        0.5,
        25,
        0.025,
        12,
        this.colorTheme,
        this.logo,
      );
      if (this.svgNode.height === 0 || this.svgNode.width === 0) {
        return;
      }
      // === set axis
      if (!spotUpdated) {
        this.minMaxYAxis = this.getMinMax(this.filteredData);
      }
      this.svgNode = this.D3Chart.setAxisDateLin(
        this.svgNode,
        this.candleData
          .map((d) => d.date)
          .concat(this.additionalDates.map((d) => d.date)),
        this.minMaxYAxis,
        false,
        true,
      );
      // initial transform - zoom
      if (this.pickedDateInterval !== "-1" || calculate) {
        let addLen = this.additionalDates.length;
        let k = this.candleData.length / (this.selectedDays + addLen);
        let tx =
          ((this.selectedDays + addLen) / this.candleData.length - 1) *
          this.svgNode.width;
        this.transform = zoomIdentity.scale(k).translate(tx, 0);
        this.xt = this.transform.rescaleX(this.svgNode.x);
        this.bandWidth =
          this.svgNode.x(this.candleData[1].date) -
          this.svgNode.x(this.candleData[0].date);
        this.candleWidth = this.bandWidth * this.barWidth + 1;
      }
      // ==== zoom setup
      this.chartBodyTA = this.svgNode
        .append("g")
        .attr("class", "chartBodyTA")
        .attr("clip-path", `url(#clipTA${this.chartName})`);
      this.svgNode
        .append("defs")
        .append("clipPath")
        .attr("id", "clipTA" + this.chartName)
        .append("rect")
        .attr("width", this.svgNode.width)
        .attr("height", this.svgNode.height);

      // === Fibonacci
      if (this.showFibo === true && this.fibonacci != null) {
        this.createFiboDataAndChart(this.chartBodyTA);
      }

      // === bollinger
      this.createBollingerChart(this.chartBodyTA);
      if (!this.showBoll) {
        this.svgNode["upperLineBoll" + this.chartName].style("opacity", 0);
        this.svgNode["upperLineBoll2" + this.chartName].style("opacity", 0);
        this.svgNode["lowerLineBoll" + this.chartName].style("opacity", 0);
        this.svgNode["lowerLineBoll2" + this.chartName].style("opacity", 0);
        this.svgNode["areaBoll2" + this.chartName].style("opacity", 0);
        this.svgNode["lineBoll" + this.chartName].style("opacity", 0);
      }

      // === Candles
      this.D3Chart.linesArea(
        this.svgNode,
        this.filteredData,
        colorExpo(this.colorTheme),
        "rgba(0,0,0,0)",
        2,
        colorExpoAlpha(this.colorTheme),
        "close",
        "zero",
        false,
        0.5,
        false,
        true,
        "upperLineTA" + this.chartName,
        "lowerLineTA" + this.chartName,
        "areaTA" + this.chartName,
        this.chartBodyTA,
      );
      this.svgNode = TACandles(
        this.svgNode,
        this.filteredData,
        colorExpo(this.colorTheme),
        dnCandles(this.colorTheme),
        "TA" + this.chartName,
        candleAlpha(this.colorTheme),
        candleAlpha(this.colorTheme),
        null,
        null,
        1,
        "id",
        "stick" + this.chartName,
        "candle" + this.chartName,
        this.chartBodyTA,
        this.candleWidth,
      );
      if (!this.isCandles) {
        this.svgNode["stick" + this.chartName].style("opacity", 0);
        this.svgNode["candle" + this.chartName].style("opacity", 0);
      } else {
        this.svgNode["upperLineTA" + this.chartName].style("opacity", 0);
        this.svgNode["lowerLineTA" + this.chartName].style("opacity", 0);
        this.svgNode["areaTA" + this.chartName].style("opacity", 0);
      }
      // === MA 20
      this.D3Chart.line(
        this.svgNode,
        this.filteredData,
        colorNet(this.colorTheme),
        2,
        "ma20",
        false,
        0,
        [],
        true,
        "lineMA20" + this.chartName,
        this.chartBodyTA,
        true,
        "id",
      );
      if (!this.show20ma) {
        this.svgNode["lineMA20" + this.chartName].style("opacity", 0);
      }
      // === MA 40
      this.D3Chart.line(
        this.svgNode,
        this.filteredData,
        colorRed(this.colorTheme),
        2,
        "ma40",
        false,
        0,
        [],
        true,
        "lineMA40" + this.chartName,
        this.chartBodyTA,
      );
      if (!this.show40ma) {
        this.svgNode["lineMA40" + this.chartName].style("opacity", 0);
      }
      // === MA 3
      this.D3Chart.line(
        this.svgNode,
        this.filteredData,
        colorFwd,
        2,
        "ma3",
        false,
        0,
        [],
        true,
        "lineMA3" + this.chartName,
        this.chartBodyTA,
      );
      if (!this.show3ma) {
        this.svgNode["lineMA3" + this.chartName].style("opacity", 0);
      }
    },
    createRSIChart() {
      if (this.candleData.length === 0) {
        return;
      }
      if (!this.showRSI) {
        return;
      }
      this.svgNodeRSI = this.D3ChartRSI.setSVG(
        0.5,
        5,
        0.5,
        60,
        0.5,
        25,
        0.025,
        12,
        this.colorTheme,
      );
      let minMaxYAxis = [0, 100];
      this.svgNodeRSI = this.D3ChartRSI.setAxisDateLin(
        this.svgNodeRSI,
        this.candleData
          .map((d) => d.date)
          .concat(this.additionalDates.map((d) => d.date)),
        minMaxYAxis,
        false,
        true,
        true,
        [0, 30, 50, 70, 100],
      );
      // ==== zoom setup
      this.chartBodyRSI = this.svgNodeRSI
        .append("g")
        .attr("class", "chartBodyRSI" + this.chartName)
        .attr("clip-path", `url(#clipRSI${this.chartName})`);
      this.svgNodeRSI
        .append("defs")
        .append("clipPath")
        .attr("id", "clipRSI" + this.chartName)
        .append("rect")
        .attr("width", this.svgNodeRSI.width)
        .attr("height", this.svgNodeRSI.height);
      this.D3ChartRSI.horizontalLine(
        this.svgNodeRSI,
        70,
        colorExpo(this.colorTheme),
        0.5,
        true,
        false,
        "rgba(0,0,0,0)",
      );
      this.D3ChartRSI.horizontalLine(
        this.svgNodeRSI,
        30,
        colorExpo(this.colorTheme),
        0.5,
        false,
        true,
        "rgba(0,0,0,0)",
      );
      this.D3ChartRSI.linesArea(
        this.svgNodeRSI,
        this.filteredData,
        "rgba(0,0,0,0)",
        "rgba(0,0,0,0)",
        0,
        colorDarkExpoAlpha(this.colorTheme),
        "rsi",
        "rsi70",
        false,
        0,
        false,
        true,
        "oSoldLineRSI" + this.chartName,
        "oSoldLineRSI" + this.chartName,
        "areaOSoldRSI" + this.chartName,
        this.chartBodyRSI,
      );
      this.D3ChartRSI.linesArea(
        this.svgNodeRSI,
        this.filteredData,
        "rgba(0,0,0,0)",
        "rgba(0,0,0,0)",
        0,
        colorDarkExpoAlpha(this.colorTheme),
        "rsi",
        "rsi30",
        false,
        0,
        false,
        true,
        "oBoughtLineRSI" + this.chartName,
        "oBoughtLineRSI" + this.chartName,
        "areaOBoughtRSI" + this.chartName,
        this.chartBodyRSI,
      );
      this.D3ChartRSI.linesArea(
        this.svgNodeRSI,
        this.filteredData,
        colorExpo(this.colorTheme),
        "rgba(0,0,0,0)",
        2,
        colorExpoAlpha(this.colorTheme),
        "rsi",
        "rsi50",
        false,
        0.5,
        false,
        true,
        "upperLineRSI" + this.chartName,
        "lowerLineRSI" + this.chartName,
        "areaRSI" + this.chartName,
        this.chartBodyRSI,
      );
    },
    createMACDChart() {
      if (this.candleData.length === 0) {
        return;
      }
      if (!this.showMACD) {
        return;
      }
      this.svgNodeMACD = this.D3ChartMACD.setSVG(
        0.5,
        5,
        0.5,
        60,
        0.5,
        25,
        0.025,
        12,
        this.colorTheme,
      );
      // ==== zoom setup
      this.chartBodyMACD = this.svgNodeMACD
        .append("g")
        .attr("class", "chartBodyMACD")
        .attr("clip-path", `url(#clipMACD${this.chartName})`);
      this.svgNodeMACD
        .append("defs")
        .append("clipPath")
        .attr("id", "clipMACD" + this.chartName)
        .append("rect")
        .attr("width", this.svgNodeMACD.width)
        .attr("height", this.svgNodeMACD.height);
      let minMaxYAxis = this.getMinMaxMACD(this.filteredData);
      this.svgNodeMACD = this.D3ChartMACD.setAxisDateLin(
        this.svgNodeMACD,
        this.candleData
          .map((d) => d.date)
          .concat(this.additionalDates.map((d) => d.date)),
        minMaxYAxis,
        false,
        true,
        false,
        [],
        "zeroLineMACD" + this.chartName,
        this.chartBodyMACD,
      );
      // lines and bars
      TABars(
        this.svgNodeMACD,
        this.filteredData,
        "macdHist" + this.chartName,
        "macdHist",
        "colorSel",
        "fillColorSel",
        1,
        "id",
        this.chartBodyMACD,
        this.candleWidth,
      );
      this.D3ChartMACD.line(
        this.svgNodeMACD,
        this.filteredData,
        colorExpo(this.colorTheme),
        2,
        "macd",
        false,
        0,
        [],
        true,
        "macd" + this.chartName,
        this.chartBodyMACD,
      );
      this.D3ChartMACD.line(
        this.svgNodeMACD,
        this.filteredData,
        dnCandles(this.colorTheme),
        2,
        "macdSignal",
        false,
        0,
        [],
        true,
        "macdSignal" + this.chartName,
        this.chartBodyMACD,
      );
    },
    createSTOCHChart() {
      if (this.candleData.length === 0) {
        return;
      }
      if (!this.showSTOCH) {
        return;
      }
      this.svgNodeSTOCH = this.D3ChartSTOCH.setSVG(
        0.5,
        5,
        0.5,
        60,
        0.5,
        25,
        0.025,
        12,
        this.colorTheme,
      );
      let minMaxYAxis = [-20, 120];
      this.svgNodeSTOCH = this.D3ChartSTOCH.setAxisDateLin(
        this.svgNodeSTOCH,
        this.candleData
          .map((d) => d.date)
          .concat(this.additionalDates.map((d) => d.date)),
        minMaxYAxis,
        false,
        false,
        true,
        [20, 50, 80],
      );
      // ==== zoom setup
      this.chartBodySTOCH = this.svgNodeSTOCH
        .append("g")
        .attr("class", "chartBodySTOCH")
        .attr("clip-path", `url(#clipSTOCH${this.chartName})`);
      this.svgNodeSTOCH
        .append("defs")
        .append("clipPath")
        .attr("id", "clipSTOCH" + this.chartName)
        .append("rect")
        .attr("width", this.svgNodeSTOCH.width)
        .attr("height", this.svgNodeSTOCH.height);
      this.D3ChartSTOCH.horizontalLine(
        this.svgNodeSTOCH,
        80,
        colorExpo(this.colorTheme),
        0.5,
        true,
        false,
        "rgba(0,0,0,0)",
      );
      this.D3ChartSTOCH.horizontalLine(
        this.svgNodeSTOCH,
        20,
        colorExpo(this.colorTheme),
        0.5,
        false,
        true,
        "rgba(0,0,0,0)",
      );
      this.D3ChartSTOCH.linesArea(
        this.svgNodeSTOCH,
        this.filteredData,
        colorExpo(this.colorTheme),
        dnCandles(this.colorTheme),
        2,
        colorExpoAlpha(this.colorTheme),
        "stochPK",
        "stochPD",
        false,
        2,
        false,
        true,
        "upperLineStochPK" + this.chartName,
        "lowerLineStochPD" + this.chartName,
        "areaStoch" + this.chartName,
        this.chartBodySTOCH,
      );
    },
    // ========== Create hover FX ============
    hoverCandle() {
      if (this.candleData.length === 0) {
        return;
      }
      if (this.svgNode.height === 0 || this.svgNode.width === 0) {
        return;
      }
      TAHover(
        this,
        this.chartBodyTA,
        colorExpo(this.colorTheme),
        dnCandles(this.colorTheme),
        "trendLine",
        0.6,
        0.6,
        colorExpo(this.colorTheme),
        dnCandles(this.colorTheme),
        this.barWidth,
        this.colorTheme,
      );
    },
    hoverRSI() {
      if (this.candleData.length === 0) {
        return;
      }
      if (this.showRSI) {
        RSIHover(this, colorExpo(this.colorTheme), this.colorTheme);
      }
    },
    hoverMACD() {
      if (this.candleData.length === 0) {
        return;
      }
      if (this.showMACD) {
        MACDHover(
          this,
          colorExpo(this.colorTheme),
          dnCandles(this.colorTheme),
          this.barWidthMACD,
          this.chartBodyMACD,
          this.colorTheme,
        );
      }
    },
    hoverSTOCH() {
      if (this.candleData.length === 0) {
        return;
      }
      if (this.showSTOCH) {
        STOCHHover(
          this,
          colorExpo(this.colorTheme),
          dnCandles(this.colorTheme),
          this.colorTheme,
        );
      }
    },
    createFiboDataAndChart(chartBody) {
      let p1, p2, date1, date2, field1, field2, nEnd2, fct1, fct2, lineData;
      let _this = this;
      let nLen = this.dChartDataRaw.length;
      let trendLen = this.fibonacci[this.fiboTerm].minMax.length;
      let num = this.fibonacci[this.fiboTerm].num;
      let nPrev = this.fibonacci[this.fiboTerm].minMax[trendLen - num - 1];
      let nInit = this.fibonacci[this.fiboTerm].minMax[trendLen - num];
      let nEnd =
        num === 1
          ? nLen + 1
          : this.fibonacci[this.fiboTerm].minMax[trendLen - num + 1] + 2;
      if (nEnd - nInit < 4) {
        nInit = nEnd - 4;
      }

      if (this.dChartDataRaw[nPrev].close > this.dChartDataRaw[nInit].close) {
        field1 = "low";
        field2 = "high";
        fct1 = min;
        fct2 = max;
      } else {
        field1 = "high";
        field2 = "low";
        fct1 = max;
        fct2 = min;
      }
      p2 = fct2(this.dChartDataRaw.slice(nInit, nEnd), function(d) {
        return d[field2];
      });
      nEnd2 =
        nInit +
        this.dChartDataRaw
          .slice(nInit, nEnd)
          .map((d) => d[field2])
          .indexOf(p2);
      date2 = this.dChartDataRaw[nEnd2].date;
      p1 = fct1(this.dChartDataRaw.slice(nInit, nEnd2), function(d) {
        return d[field1];
      });
      date1 = this.dChartDataRaw[
        nInit +
          this.dChartDataRaw
            .slice(nInit, nEnd2)
            .map((d) => d[field1])
            .indexOf(p1)
      ].date;
      if (date1 > date2) {
        let tempData = date1;
        date1 = date2;
        date2 = tempData;
        tempData = p1;
        p1 = p2;
        p2 = tempData;
      }

      let n = this.candleData.length - 1;
      this.candleData.every(function(d, i) {
        if (i === 0) {
          if (date1 < d.date) {
            nInit = 0;
          }
        } else if (i < n) {
          if (date1 >= d.date && date1 < _this.candleData[i + 1].date) {
            nInit = i;
          }
        } else {
          if (date1 >= d.date) {
            nInit = i;
          }
        }
        if (i === 0) {
          if (date2 < d.date) {
            nEnd2 = 0;
            return false;
          }
        } else if (i < n) {
          if (date2 >= d.date && date2 < _this.candleData[i + 1].date) {
            nEnd2 = i;
            return false;
          }
        }
        return true;
      });

      if (this.interval !== "day") {
        let interval = this.interval === "week" ? "1W" : "1M";
        date1 = timeCompare(date1, interval, [{ date: date1 }]);
        date2 = timeCompare(date2, interval, [{ date: date2 }]);
      }

      let px = this.processData.fiboLowHighToPrices(p1, p2, this.pxPercent);
      let fiboData = [
        {
          date: _this.candleData[nInit].date,
          p1: px[0],
          p2: px[1],
          p3: px[2],
          p4: px[3],
          p5: px[4],
          p6: px[5],
          p7: px[6],
        },
        {
          date: _this.additionalDates[_this.additionalDates.length - 1].date,
          p1: px[0],
          p2: px[1],
          p3: px[2],
          p4: px[3],
          p5: px[4],
          p6: px[5],
          p7: px[6],
        },
      ];
      if (this.showFiboR) {
        let keys = Object.keys(fiboData[0]);
        this.D3Chart.multiLinesArea(
          this.svgNode,
          fiboData,
          fibonacciColorSelection,
          2.5,
          fibonacciAreaSelection,
          keys.splice(1),
          false,
          true,
          "fiboR" + this.chartName,
          chartBody,
        );
      }

      this.fiboTrendData = [
        { date: date1, value: p1 },
        { date: date2, value: p2 },
      ];
      this.D3Chart.line(
        this.svgNode,
        this.fiboTrendData,
        textactive(this.colorTheme),
        0.5,
        "value",
        false,
        0,
        [],
        true,
        "trendFibo" + this.chartName,
        chartBody,
      );
      let del = p1 > p2 ? -5 : 5;
      var sym = symbol()
        .type(symbolSquare)
        .size(20);
      this.svgNode["diamondFibo1"] = chartBody
        .append("path")
        .attr("d", sym)
        .attr("fill", colorExpo(this.colorTheme))
        .attr("stroke", textinactive(this.colorTheme))
        .attr(
          "transform",
          `translate(${_this.svgNode.x(date1)},${_this.svgNode.y(p1) +
            del}) rotate(45)`,
        );
      this.svgNode["diamondFibo2"] = chartBody
        .append("path")
        .attr("d", sym)
        .attr("fill", colorExpo(this.colorTheme))
        .attr("stroke", textinactive(this.colorTheme))
        .attr(
          "transform",
          `translate(${_this.svgNode.x(date2)},${_this.svgNode.y(p2) -
            del}) rotate(45)`,
        );

      let minMax = [
        this.svgNode.y.invert(this.svgNode.height),
        this.svgNode.y.invert(0),
      ];
      let nPx;
      if (this.showFiboE) {
        let del1 = Math.abs(px[4] - px[0]);
        let del2 = Math.abs(px[3] - px[0]);
        let del3 = Math.abs(px[2] - px[0]);
        let dat = this.additionalDates[this.additionalDates.length - 1].date;
        let pxPerc = [1.382, 1.5, 1.618, 1.618, 1.5, 1.382];
        let pxExt = [
          Math.max(px[0], px[6]) + del3,
          Math.max(px[0], px[6]) + del2,
          Math.max(px[0], px[6]) + del1,
          Math.min(px[0], px[6]) - del1,
          Math.min(px[0], px[6]) - del2,
          Math.min(px[0], px[6]) - del3,
        ];
        let txtExt = [];
        nPx = pxExt.length - 1;
        let nLen = fibonacciColorSelection.length - 1;
        for (let i = 0; i <= nPx; i++) {
          lineData = [
            { date: date1, value: pxExt[i] },
            { date: dat, value: pxExt[i] },
          ];
          this.D3Chart.line(
            this.svgNode,
            lineData,
            fibonacciColorSelection[nLen - i],
            2,
            "value",
            false,
            0,
            [],
            true,
            "fiboE" + this.chartName + i,
            chartBody,
          );

          txtExt.push({
            date: fiboData[0].date,
            px: pxExt[i],
            txt:
              format(_this.formatPercent)(pxPerc[i]) +
              " (" +
              format(_this.currencyFormat)(pxExt[i]) +
              ")",
          });
        }
        this.D3Chart.text(
          this.svgNode,
          txtExt,
          "date",
          "px",
          "txt",
          "FiboETxt" + this.chartName,
          "12px",
          -5,
          0,
          "end",
          "central",
          0,
          textactive(this.colorTheme),
          true,
          chartBody,
        );
      }

      if (this.showFiboR) {
        let txtData = px.map(function(d, i) {
          // if (i == 0 || i == 3 || i === 6) {
          return {
            date: fiboData[0].date,
            px: d,
            txt:
              format(_this.formatPercent)(_this.pxPercent[i]) +
              " (" +
              format(_this.currencyFormat)(d) +
              ")",
          };
          // }
        });
        // txtData = txtData.filter(d => d !== undefined);
        this.D3Chart.text(
          this.svgNode,
          txtData,
          "date",
          "px",
          "txt",
          "FiboRTxt" + this.chartName,
          "12px",
          -5,
          0,
          "end",
          "central",
          0,
          textactive(this.colorTheme),
          true,
          chartBody,
        );
      }

      if (this.showFiboTE) {
        this.fiboTEData = [];
        let nAdd = this.additionalDates.length;
        let pRef = [0, 1, 1.382, 1.618, 2, 2.382, 2.618, 4.236];
        nPx = pRef.length - 1;
        let nDays = nEnd2 - nInit;
        let nDraw;
        let txtTE = [];
        for (let i = 0; i < pRef.length; i++) {
          nDraw = nInit + Math.round(nDays * pRef[i]);
          if (nDraw > nAdd + n - 1) {
            break;
          } else if (nDraw > n - 1) {
            lineData = [
              {
                date: this.additionalDates[nDraw - n].date,
                value: minMax[0],
                hei: 0,
              },
              {
                date: this.additionalDates[nDraw - n].date,
                value: minMax[1],
                hei: 1,
              },
            ];
          } else {
            lineData = [
              { date: this.candleData[nDraw].date, value: minMax[0], hei: 0 },
              { date: this.candleData[nDraw].date, value: minMax[1], hei: 1 },
            ];
          }
          this.fiboTEData.push(lineData);
          let line = line()
            .curve(curveMonotoneX)
            .defined((d) => !Number.isNaN(d["value"]))
            .x((d) => _this.svgNode.x(d.date))
            .y((d) => (d["hei"] === 0 ? _this.svgNode.height : 0));
          _this.svgNode["fiboTE" + this.chartName + i] = chartBody
            .append("g")
            .attr("fill", "none")
            .attr("stroke-width", 0.5)
            .attr("stroke-linejoin", "round")
            .attr("stroke-linecap", "round")
            .style("shape-rendering", "crispEdges")
            .selectAll("path")
            .data([lineData])
            .join("path")
            .style(
              "stroke",
              i <= 1
                ? textinactive(this.colorTheme)
                : fibonacciColorSelection[i - 2],
            )
            .attr("d", (d) => line(d))
            .style("vector-effect", "non-scaling-stroke");

          txtTE.push({
            date: lineData[0].date,
            px: minMax[0],
            txt: format(_this.formatPercent)(pRef[i]),
          });
        }
        this.D3Chart.text(
          this.svgNode,
          txtTE,
          "date",
          "px",
          "txt",
          "FiboTETxt" + this.chartName,
          "12px",
          0,
          0,
          "end",
          "ideographic",
          90,
          textactive(this.colorTheme),
          true,
          chartBody,
        );
      }
    },
    createBollingerChart(chartBody) {
      if (this.candleData.length === 0) {
        return;
      }
      this.D3Chart.line(
        this.svgNode,
        this.filteredData,
        colorDarkHedge(this.colorTheme),
        2,
        "bband_u2",
        false,
        0,
        [],
        true,
        "upperLineBoll" + this.chartName,
        chartBody,
      );
      this.D3Chart.line(
        this.svgNode,
        this.filteredData,
        colorDarkHedge(this.colorTheme),
        2,
        "bband_l2",
        false,
        0,
        [],
        true,
        "lowerLineBoll" + this.chartName,
        chartBody,
      );
      this.D3Chart.linesArea(
        this.svgNode,
        this.filteredData,
        colorHedge(this.colorTheme),
        colorHedge(this.colorTheme),
        2,
        colorHedgeAlpha(this.colorTheme),
        "bband_l1",
        "bband_u1",
        false,
        2,
        false,
        true,
        "upperLineBoll2" + this.chartName,
        "lowerLineBoll2" + this.chartName,
        "areaBoll2" + this.chartName,
        chartBody,
      );
      this.D3Chart.line(
        this.svgNode,
        this.filteredData,
        colorHedge(this.colorTheme),
        2,
        "bband_ma",
        false,
        1 / 22,
        [],
        true,
        "lineBoll" + this.chartName,
        chartBody,
      );
    },
    callWidth() {
      if (this.chartDataRaw.length > 0 && this.showLoading === false) {
        setTimeout(() => {
          this.createAllCharts();
        }, 500);
      }
    },
  },
};
</script>
<style scoped>
.axis path {
  display: none !important;
}

.axis line {
  stroke-opacity: 0.3 !important;
}
.line {
  fill: none !important;
  stroke: steelblue !important;
  stroke-width: 3px !important;
}

.site--hover {
  stroke: #000 !important;
  stroke-width: 4px !important;
}

button {
  position: absolute !important;
  top: 20px !important;
  left: 80px !important;
}

.voronoi path {
  fill: none !important;
  pointer-events: all !important;
}

.voronoi--show path {
  stroke: red !important;
  stroke-opacity: 0.2 !important;
}
@media (max-width: 1150px) {
  .textCandleChart {
    font-size: 0.8rem !important;
  }
  .textCurrency {
    font-size: 0.9rem !important;
  }
}
</style>
